var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 38,
    height: 38
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_41_6935_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 10,
    cx: 9,
    cy: 9,
    r: 8.8,
    transform: "rotate(-180 9 9)",
    fill: "black",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50003 5.50047C7.56583 5.50009 7.63107 5.51271 7.69198 5.53759C7.7529 5.56247 7.80831 5.59913 7.85503 5.64547L10.855 8.64547C10.9482 8.73916 11.0004 8.86588 11.0004 8.99797C11.0004 9.13007 10.9482 9.25679 10.855 9.35047L7.85503 12.3505C7.75938 12.4324 7.63634 12.4752 7.5105 12.4703C7.38467 12.4655 7.2653 12.4133 7.17625 12.3243C7.0872 12.2352 7.03504 12.1158 7.03018 11.99C7.02531 11.8642 7.06812 11.7411 7.15003 11.6455L9.79503 9.00047L7.15003 6.35547C7.07982 6.28584 7.03184 6.19695 7.01214 6.10004C6.99245 6.00313 7.00194 5.90256 7.0394 5.81105C7.07686 5.71953 7.14062 5.64118 7.22261 5.5859C7.3046 5.53062 7.40115 5.50089 7.50003 5.50047Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_41_6935_clip_path",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.8,
    transform: "rotate(-180 9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSliderArrow);
export default __webpack_public_path__ + "static/media/RightSliderArrow.92f112c8939d380f8dd566d9fc35b28a.svg";
export { ForwardRef as ReactComponent };